import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import EditProfileComponent from "./EditProfileComponent";
import LayoutAction from "../../../modules/actions/LayoutAction";

const mapStateToProps = (state) => {
  return {
    userProfile: state.LayoutReducer.loggedInProfile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    LayoutAction: bindActionCreators(LayoutAction, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditProfileComponent);
